import { getNotifications, markNotificationRead, markAllNotificationsRead } from '@/services/notificationsService'

var PAGE_SIZE = 20

function normalizeItem (n, fallbackLink) {
  return {
    id: n.id,
    type: n.type || 'INFO',
    jobId: n.jobId || n.referenceId || null,
    title: n.subject || n.title || n.message || '',
    body: n.body || n.description || '',
    link: n.link || fallbackLink,
    timestamp: n.createdAt || n.timestamp || new Date().toISOString(),
    read: !!(n.read)
  }
}

export default {
  namespaced: true,
  state: function () {
    return {
      items: [],
      loading: false,
      page: 0,
      hasMore: true
    }
  },
  getters: {
    ALL: function (state) { return state.items },
    UNREAD_COUNT: function (state) {
      return state.items.filter(function (n) { return !n.read }).length
    }
  },
  mutations: {
    SET_ITEMS: function (state, items) { state.items = items },
    APPEND_ITEMS: function (state, items) {
      var seen = {}
      state.items.forEach(function (n) { seen[n.id] = true })
      var fresh = items.filter(function (n) { return !seen[n.id] })
      state.items = state.items.concat(fresh)
    },
    SET_LOADING: function (state, val) { state.loading = val },
    SET_PAGE: function (state, page) { state.page = page },
    SET_HAS_MORE: function (state, val) { state.hasMore = val },
    RESET: function (state) {
      state.items = []
      state.page = 0
      state.hasMore = true
    },
    MARK_READ: function (state, id) {
      var n = state.items.find(function (n) { return n.id === id })
      if (n) n.read = true
    },
    MARK_ALL_READ: function (state) {
      state.items.forEach(function (n) { n.read = true })
    }
  },
  actions: {
    FETCH: function (context) {
      var user = context.rootState.user
      if (!user) return Promise.resolve()
      var isEngineer = user.role === 'ENGINEER' || user.role === 'ADMIN'
      var fallbackLink = isEngineer ? '/engineer/jobs' : '/projects'
      context.commit('RESET')
      context.commit('SET_LOADING', true)
      return getNotifications({ page: 0, size: PAGE_SIZE })
        .then(function (data) {
          var raw = Array.isArray(data) ? data : (data && data.content ? data.content : [])
          var hasMore = Array.isArray(data) ? raw.length === PAGE_SIZE : (data ? !data.last : false)
          var items = raw.map(function (n) { return normalizeItem(n, fallbackLink) })
          items.sort(function (a, b) { return new Date(b.timestamp) - new Date(a.timestamp) })
          context.commit('SET_ITEMS', items)
          context.commit('SET_PAGE', 1)
          context.commit('SET_HAS_MORE', hasMore)
          context.commit('SET_LOADING', false)
        })
        .catch(function () {
          context.commit('SET_LOADING', false)
        })
    },
    LOAD_MORE: function (context) {
      if (context.state.loading || !context.state.hasMore) return Promise.resolve()
      var user = context.rootState.user
      if (!user) return Promise.resolve()
      var isEngineer = user.role === 'ENGINEER' || user.role === 'ADMIN'
      var fallbackLink = isEngineer ? '/engineer/jobs' : '/projects'
      var nextPage = context.state.page
      context.commit('SET_LOADING', true)
      return getNotifications({ page: nextPage, size: PAGE_SIZE })
        .then(function (data) {
          var raw = Array.isArray(data) ? data : (data && data.content ? data.content : [])
          var hasMore = Array.isArray(data) ? raw.length === PAGE_SIZE : (data ? !data.last : false)
          var items = raw.map(function (n) { return normalizeItem(n, fallbackLink) })
          context.commit('APPEND_ITEMS', items)
          context.commit('SET_PAGE', nextPage + 1)
          context.commit('SET_HAS_MORE', hasMore)
          context.commit('SET_LOADING', false)
        })
        .catch(function () {
          context.commit('SET_LOADING', false)
        })
    },
    MARK_READ: function (context, id) {
      context.commit('MARK_READ', id)
      return markNotificationRead(id).catch(function () {})
    },
    MARK_ALL_READ: function (context) {
      context.commit('MARK_ALL_READ')
      return markAllNotificationsRead().catch(function () {})
    }
  }
}
